import { sumByCategory } from "./collectionUtils";

export const calculateGrossMargin = (pnlData = {}) => {
  const revenue = sumByCategory(pnlData.revenue || []);
  const cogs = sumByCategory(pnlData.cost_of_goods_sold || []);
  const grossProfit = revenue - cogs;

  return revenue > 0 ? (grossProfit / revenue) * 100 : 0;
};

export const calculateOperatingMargin = (pnlData = {}) => {
  const revenue = sumByCategory(pnlData.revenue || []);
  const expenses = sumByCategory(pnlData.expenses || []);
  const operatingProfit = revenue - expenses;

  return revenue > 0 ? (operatingProfit / revenue) * 100 : 0;
};
